import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import LineBookReaderIcon from 'LuxKit/Icons/line/LineBookReaderIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineLuggageIcon from 'LuxKit/Icons/line/LineLuggageIcon'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const SectionContainer = styled(LayoutContainer)`
  padding-bottom: 0;
`

const CardsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};

  ${mediaQueryUp.desktop} {
    flex-direction: row;
    gap: ${rem(20)};
  }
`

const Card = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`

const IconWrapper = styled.div`
  width: ${rem(48)};
  height: ${rem(48)};
  border-radius: 50%;
  background: #F3F3F4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: ${rem(12)};

  svg {
    width: ${rem(29)};
    height: ${rem(29)};
  }

  ${mediaQueryUp.desktop} {
    width: ${rem(56)};
    height: ${rem(56)};
    margin-bottom: ${rem(12)};

    svg {
      width: ${rem(34)};
      height: ${rem(34)};
    }
  }
`

const CARDS = [
  {
    icon: <LineBookReaderIcon />,
    title: 'Travel managers',
    description: 'One platform to manage bookings, policies and travellers with less admin and more visibility.',
  },
  {
    icon: <LineUsdCircleIcon />,
    title: 'Finance teams',
    description: 'Automated approvals, clearer reporting and predictable spend across every trip.',
  },
  {
    icon: <LineLuggageIcon />,
    title: 'Travellers',
    description: 'Easy booking, extensive options and 24/7 support, all within company policy.',
  },
]

function BusinessTravellerEasyForAllSection() {
  return <SectionContainer>
    <Group direction="vertical" gap={40} desktopGap={48} desktopHorizontalAlign="center">
      <Group direction="vertical" gap={12} desktopHorizontalAlign="center">
        <Heading variant="heading2" align="start" desktopAlign="center">
          <i>Easy</i> for everyone to use
        </Heading>
        <BodyText variant="large" align="start" desktopAlign="center">
          From finance teams to frequent travellers, Business Traveller works seamlessly across your organisation.
        </BodyText>
      </Group>

      <CardsGrid>
        {CARDS.map(card => (
          <Card key={card.title}>
            <IconWrapper>{card.icon}</IconWrapper>
            <Heading variant="heading4">{card.title}</Heading>
            <BodyText variant="large">{card.description}</BodyText>
          </Card>
        ))}
      </CardsGrid>
    </Group>
  </SectionContainer>
}

export default BusinessTravellerEasyForAllSection
